import React from 'react';
import { observer } from 'mobx-react';

import { enforceParameters } from '../../hocs/enforce-parameters';
import { SimpleButton } from '../simple-button';
import { ConfigParametersStore } from '../../stores/ConfigParametersStore';
import styles from './IntranetToggle.css';

const toggleWeb = () => {
  ConfigParametersStore.toggleWeb();
  window.location.reload();
};

const IntranetToggle = () => {
  if (!ConfigParametersStore.isIntranet) {
    return null;
  }

  return (
    <div className={styles.container}>
      <p className={styles.message}>
        Usted está viendo la&nbsp;
        <u>
          {ConfigParametersStore.webToggled ? 'web' : 'intranet'}
        </u>
      </p>
      <SimpleButton onClick={toggleWeb}>
        Cambiar
      </SimpleButton>
    </div>
  );
};

const ObservedIntranetToggle = enforceParameters(observer(IntranetToggle));

export { ObservedIntranetToggle as IntranetToggle };



// WEBPACK FOOTER //
// ./src/common/intranet-toggle/IntranetToggle.jsx